import { useState } from 'react';
import { useDebounce } from 'react-use';

import { Option, PostalCode } from 'types';

import { geonamesDataService } from 'services/geonames.service';

const usePostalCode = (countryCode: string) => {
  const [postalCode, postalCodeSet] = useState<string>('');
  const [postalCodes, postalCodesSet] = useState<Option[]>([]);
  const [loadingPostalCodes, loadingPostalCodesSet] = useState<boolean>(false);

  const resIntoOptions = (postalCodesRes: PostalCode[]) =>
    postalCodesRes?.map((item: PostalCode): Option => {
      const label =
        item.latinAdminName2 ||
        item.adminName2 ||
        item.latinAdminName1 ||
        item.adminName1 ||
        item.latinAdminName3 ||
        item.adminName3;

      return {
        value: item.postalCode.replaceAll('-', ' '),
        label: `${label}, ${item.toponymName || item.placeName}, ${item.postalCode} `,
        additional: {
          province: item.latinAdminName2 || item.adminName2,
          city: item.toponymName || item.placeName,
        },
      };
    });

  useDebounce(
    async () => {
      if (!countryCode) return;
      loadingPostalCodesSet(true);

      await geonamesDataService.get(countryCode, postalCode).then((res) => {
        if (res.data && res.data.length > 0) {
          postalCodesSet(resIntoOptions(res.data));
        } else {
          postalCodesSet([
            {
              value: postalCode,
              label: postalCode,
            },
          ]);
        }
      });
      loadingPostalCodesSet(false);
    },
    350,
    [countryCode, postalCode]
  );

  return {
    postalCodes,
    postalCodeSet,
    loadingPostalCodes,
  };
};

export { usePostalCode };
